<template>
    <div ref="kimMeet" class="video-container">
        <v-progress-circular
                v-if="loadingVideo"
                indeterminate
                color="white"
                class="video-spinner mx-auto"
                size="60" width="2" >
            <v-icon color="white" size="20">fa-video</v-icon>
        </v-progress-circular>
    </div>
</template>
<script>
    export default{
        props:{
            user:{
                type: Object
            },
            roomId: {
                type: String,
                required: true
            },
            height: {
                type: [String, Number],
                default: '500px'
            },
            width: {
                type: [String, Number],
                default: '100%'
            },
            performanceMode:{
                type: Boolean,
                default: false
            },

            /*
              Available Controls:
              ---------------------------------------------------------------------------------------
             'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
             'fodeviceselection', 'hangup', 'profile', 'chat', 'recording',
             'livestreaming', 'etherpad', 'sharedvideo', 'settings', 'raisehand',
             'videoquality', 'filmstrip', 'invite', 'feedback', 'stats', 'shortcuts',
             'tileview', 'videobackgroundblur', 'download', 'help', 'mute-everyone', 'security'
             ---------------------------------------------------------------------------------------
             */

            controls:{
                type: Array,
                default: () => []
            }
        },
        data(){
            return {
                loadingVideo: true
            }
        },
        mounted(){
            var vm = this
            vm.initialize()
        },
        methods:{
            initialize(){

                var vm = this
                const domain = process.env.VUE_APP_KIM_MEET_URL
                const ref = vm.$refs.kimMeet

                var options = {
                    roomName: vm.roomId,
                    width: vm.width,
                    height: vm.height,
                    configOverwrite: { subject: vm.appName, defaultLanguage: 'es' },
                    interfaceConfigOverwrite: vm.interfaceOptions,
                    parentNode: ref,
                    onload: () => {
                        vm.loadingVideo = false
                        vm.$emit('load')
                    }
                };


                if(vm.user){
                    options.userInfo = vm.user
                }

                const api = new JitsiMeetExternalAPI(domain, options);
                api.executeCommand('subject', ' ');
            }
        },
        computed:{
            interfaceOptions(){
                var vm = this

                var defaultOptions = {
                  LANG_DETECTION: true,
                  HIDE_INVITE_MORE_HEADER: true,
                  VIDEO_QUALITY_LABEL_DISABLED: true,
                  SHOW_CHROME_EXTENSION_BANNER: false
                }

                if(vm.controls.length > 0){
                    defaultOptions.TOOLBAR_BUTTONS = vm.controls
                }

                if(vm.performanceMode){
                    defaultOptions.SET_FILMSTRIP_ENABLED = false
                    defaultOptions.DISABLE_FOCUS_INDICATOR = true
                    defaultOptions.DISABLE_DOMINANT_SPEAKER_INDICATOR = true
                    defaultOptions.DISABLE_VIDEO_BACKGROUND = true
                }

                return defaultOptions

            }
        }
    }
</script>

<style scoped>
    .video-container{
        height: 100%;
        width: 100%;
        background-color: #1b2637;
        align-items: center;
        justify-content: center;
        display: flex;
    }
    .video-spinner{
        position: absolute;
    }
</style>
